import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export function useFromLocationState() {
  const location = useLocation();
  return useMemo(
    () => ({ from: `${location.pathname}${location.search}` }),
    [location.pathname, location.search],
  );
}
